import type { ComponentMode, FileOwnerType, PaymentGateway } from 'types';

interface State extends PaymentGateway {
  mode: ComponentMode;
  ownerType: FileOwnerType;
  defaultTitle: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_PAYMENT_GATEWAY_ICON';
      payload: Pick<typeof initialState, 'iconId'>;
    }
  | {
      type: 'UPDATE_PAYMENT_GATEWAY_DISCOUNT_TYPE';
      payload: Pick<typeof initialState, 'discountType'>;
    }
  | {
      type: 'UPDATE_PAYMENT_GATEWAY_DISCOUNT_AMOUNT';
      payload: Pick<typeof initialState, 'discountAmount'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
